<template>
  <div>
      <router-view
        :custom-color="customColor"
        :custom-background="customBackground"
        :custom-style="customStyle"
      />
  </div>
</template>

<script>
  import './assets/fonts.css'

  export default {
    name: 'app',
    computed: {
      customStyle () {
        return {
          background: this.customBackground,
          color: this.customColor
        }
      },
      customColor () {
        if (this.$route.query.color) {
          return `#${this.$route.query.color}`
        }
        return null
      },
      customBackground () {
        const backgroundStyle = this.$route.query.background
        const bg = (backgroundStyle || '').split(',')
        if (backgroundStyle && bg.length === 1) {
          return `#${bg[0]}`
        }
        if (backgroundStyle && bg.length === 2) {
          return `linear-gradient(90deg, #${bg[0]} 0%, #${bg[1]} 100%)`
        }
        return backgroundStyle
      }
    }
  }
</script>

<style>
    body, html {
        margin: 0;
        padding: 0;
        font-family: 'Avenir Next LT Pro', Helvetica, sans-serif;
    }

    .news {
        display: flex;
        flex: 1;
    }

    .sedna-slider-app {
        margin: 0;
        padding: 30px 50px 20px 50px;
        width: 1500px;
        height: 405px;
        box-sizing: border-box;
    }

    .aretv {
        font-family: 'AvenirNext LT Pro', Helvetica, sans-serif; /* NOTE: "AvenirNext" as opposed to "Avenir Next" */
        margin: 0;
        padding: 30px 50px 20px 50px;
        width: 1920px;
        height: 490px;
        box-sizing: border-box;
    }

    .sedna-slider-app, .sedna-slider-app * {
        font-family: 'Avenir Next LT Pro', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #fff;
    }

    .panels-grid .grid-item {
      box-sizing: border-box;
      width: 310px;
      height: 340px;
      border: 1px solid;
      padding: 20px;
    }

    .aretv.panels-grid {
      padding: 75px 97px;
    }
    .aretv.panels-grid .grid-item {
      justify-content: space-between;
    }

    @font-face {
        font-family: 'Avenir Next LT Pro';
        src: url('assets/fonts/subset-AvenirNextLTPro-Demi.eot');
        src: url('assets/fonts/subset-AvenirNextLTPro-Demi.eot?#iefix') format('embedded-opentype'),
        url('assets/fonts/subset-AvenirNextLTPro-Demi.ttf') format('truetype'),
        url('assets/fonts/subset-AvenirNextLTPro-Demi.svg#AvenirNextLTPro-Demi') format('svg');
        font-weight: normal;
        font-style: normal;
    }


</style>
